<template>
    <section class="card">
        <div v-for="opt in children" :key="opt.props.value.val">
            <tr-text
                :tracker="tracker"
                v-bind="opt.props.label"
                @edit-tr="$emit('edit-tr', $event)"
                @tr-unit-activated="$emit ('tr-open-modal', $event)"
            ></tr-text>
        </div>
    </section>
</template>

<script>
import TrText                 from "@/components/translation/TrText"
import TrDisplay              from "@/components/translation/TrDisplay"

export default {
    name: "I18nItemTranslationModal",
    components: {TrText, TrDisplay},
    props: ["props", "children", "tracker"],
}
</script>

<style scoped>
    section.card {
        border: 2px solid red;
        border-top-width: 0;
        border-bottom-left-radius  : 5px;
        border-bottom-right-radius : 5px;
    }
</style>